/**
 * @generated SignedSource<<76edd3f2b42982a2736f6867c8067731>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type IndividualStudentReportUserTimeQuery$variables = {
  date: any;
  userId: string;
};
export type IndividualStudentReportUserTimeQuery$data = {
  readonly getUserTimeOnPlatform: {
    readonly totalMinutes: number;
  };
};
export type IndividualStudentReportUserTimeQuery = {
  response: IndividualStudentReportUserTimeQuery$data;
  variables: IndividualStudentReportUserTimeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "date"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "date",
        "variableName": "date"
      },
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": "UserTimeOnPlatform",
    "kind": "LinkedField",
    "name": "getUserTimeOnPlatform",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalMinutes",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IndividualStudentReportUserTimeQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IndividualStudentReportUserTimeQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c136cb2267c9c8bdcbcfbdbc0188e807",
    "id": null,
    "metadata": {},
    "name": "IndividualStudentReportUserTimeQuery",
    "operationKind": "query",
    "text": "query IndividualStudentReportUserTimeQuery(\n  $date: DateTime!\n  $userId: ID!\n) {\n  getUserTimeOnPlatform(date: $date, userId: $userId) {\n    totalMinutes\n  }\n}\n"
  }
};
})();

(node as any).hash = "2464391a24cea5d77c67fce56c33e411";

export default node;
